import { trackEvent, EC_ACCOUNT, E_OPEN_NAVIGATION, E_CLOSE_NAVIGATION } from "../helpers/tracking";

export const OPEN_NAVIGATION = "OPEN_NAVIGATION";
export const CLOSE_NAVIGATION = "CLOSE_NAVIGATION";

export function setNavigation(open) {
	return function (dispatch) {
		dispatch({
			type: open ? OPEN_NAVIGATION : CLOSE_NAVIGATION
		});
		if (open) {
			trackEvent(EC_ACCOUNT, E_OPEN_NAVIGATION);
		} else {
			trackEvent(EC_ACCOUNT, E_CLOSE_NAVIGATION);
		}
	}
}

export function toggleNavigation() {
	return function (dispatch, getState) {
		const { navigation: { open } } = getState();
		dispatch(setNavigation(!open));
	}
}